import {
  ChatBannerExperiment,
  SidebarAIBannerVariant,
} from "@clockwise/web-commons/src/components/chat-banner/ChatBannerExperiment";
import React from "react";
import { useLocalStorage } from "usehooks-ts";

export const ChatSidebarBanner = () => {
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    "ClockwiseAI:TryAIBannerDismissed",
    false,
  );

  const onDismissBanner = () => {
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="cw-mx-[11px] cw-mb-[30px] cw-w-full cw-max-w-[280px]">
      <ChatBannerExperiment onDismiss={onDismissBanner} variant={SidebarAIBannerVariant.Prism} />
    </div>
  );
};
